import React from "react";
import { Spinner } from "react-bootstrap";

const ComponentLoader = (props) => {
  const { className } = props;
  return <Spinner animation="border" className={className ? className : ""} />;
};

export default ComponentLoader;
